<template>
  <div>
    <el-form
      ref="dataForm"
      size="small"
      label-position="top"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('orderCenterCont.DownloadTemplate')">
            <div ref="download1">
              <span style="cursor: pointer" @click="initDown()">
                <span style="color:#409eff;">补开cte发票模板(Preencher o modelo de factura CT-e).xlsx</span>
                <span class="el-icon-download" style="color:#409eff;margin-left: 20px" />
              </span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$t('basicData.UploadTheFile')"
          >
            <el-upload
              ref="demoUpload"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :http-request="upLoad"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              action
              class="upload-demo"
              drag
              multiple
            >
              <i class="el-icon-plus" style="margin: 50px auto 20px;" />
              <!-- 点击或拖拽文件到此处上传 -->
              <div class="el-upload__text">{{ $t('orderImport.cldrUpload') }}</div>
              <!--请上传 .xlsx, .xls 文件-->
              <div class="el-upload__text">{{ $t('basicData.PleaseUploadExcelFiles') }}</div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--补开cte发票结果-->
    <el-dialog
      :title="$t('mdfeTranslate.ReopenCTeInvoiceResult')"
      :visible.sync="showBatchCancelResult"
      width="600px"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="padding: 20px 0">
        <div v-if="percentage >= 100" style="display: flex;margin-bottom: 20px;">
          <div style="flex: 1">{{ $t('organizationManage.all') }}：{{ excelJsonData.length }}</div>
          <div style="flex: 1">{{ $t('organizationManage.succeed') }}：{{ successCount }}</div>
          <div style="flex: 1">{{ $t('operationCenter.fail') }}：{{ failCount }}</div>
        </div>
        <el-progress
          :text-inside="true"
          text-color="#fff"
          :stroke-width="26"
          :percentage="percentage"
        />
        <div v-if="percentage >= 100" style="margin-top: 20px;">
          <div ref="download1" style="margin-bottom: 20px;">
            <div style="margin-bottom: 10px;">{{ $t('mdfeTranslate.ReopenCTeInvoiceResult') }}：</div>
            <span style="cursor: pointer" @click="downloadResult()">
              <span style="color:#409eff;">补开cte发票结果(Resultado da Reabertura da Fatura CT-e).xlsx</span>
              <span class="el-icon-download" style="color:#409eff;margin-left: 20px" />
            </span>
          </div>
        </div>
      </div>
      <div v-if="percentage >= 100" slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmClose">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as XLSX from 'xlsx';
import ExcelJs from 'exceljs';
import { saveAs } from 'file-saver';
import { reopenCteInvoice } from '@/api/invoiceCenter';
export default {
  name: 'Invoice',
  props: {
    multipleSelection: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      allResult: [],
      fileList: [],
      headKey: {
        'waybillNumber(运单号)': 'waybillNumber',
        'packageNo(子包号)': 'packageNo',
        'cteKey(发票密钥)': 'cteKey',
        'frete(快递费)': 'FY001',
        '% gris e advalorem(从价)': 'FY013',
        'seguro(保险)': 'FY005',
        '% Tax (ICMS / ISS)(icms税率，必须小于1)': 'taxRate',
        'valorIcms(icms税费)': 'FY008'
      },
      excelJsonData: [],
      successCount: 0,
      failCount: 0,
      showBatchCancelResult: false,
      percentage: 0
    };
  },
  methods: {
    // 下载模板
    initDown() {
      const a = document.createElement('a');
      a.href = '/static/补开cte发票模板(Preencher o modelo de factura CT-e).xlsx';
      a.download = '补开cte发票模板(Preencher o modelo de factura CT-e)';
      a.style.display = 'none';
      this.$nextTick(() => {
        this.$refs.download1.appendChild(a);
      });
      a.click();
      a.remove();
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['xls', 'xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('collectionCenter.uploadOnlyXlsx'));
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        // 上传文件大小不能超过 10MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    upLoad(option) {
      const file = option.file;
      this.parseExcelToJson(file);
    },
    // 解析Excel文件为JSON对象数组，格式为[{表头：value}]
    parseExcelToJson(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // 将工作表直接转换为JSON对象数组，格式为[{表头：value}]
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.excelJsonData = jsonData.map(item => {
            const transformedItem = {};
            for (const [originalKey, value] of Object.entries(item)) {
              if (this.headKey[originalKey]) {
                transformedItem[this.headKey[originalKey]] = value;
              }
            }
            return transformedItem;
          });
        } catch (error) {
          this.$message.error(error.message);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    handleRemove() {
      this.fileList = [];
      this.excelJsonData = [];
    },
    handleExceed() {
      this.$message.error(this.$t('basicData.Only1FileCanBeUploadedAtATime'));
    },
    submitForm() {
      if (this.excelJsonData.length === 0) {
        this.$message.error(this.$t('basicData.PleaseUploadExcelFiles'));
        return;
      }
      // 请确认是否补开以上订单数据CTE
      this.$confirm(this.$t('mdfeTranslate.PleaseConfirmWhetherToReopenTheAboveOrderDataCTE'), this.$t('mdfeTranslate.CTEReopenConfirmation'), {
        confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
        cancelButtonText: this.$t('GlobalSetObj.cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        // 请二次确认是否补开以上订单数据CTE
        this.$confirm(this.$t('mdfeTranslate.PleaseAgainConfirmWhether'), this.$t('mdfeTranslate.CTEReopenConfirmation'), {
          confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
          cancelButtonText: this.$t('GlobalSetObj.cancel'), // '取消',
          type: 'warning'
        }).then(async() => {
          this.showBatchCancelResult = true;
          const param = this.excelJsonData.map(item => {
            const transformedItem = {
              waybillNumber: '',
              packageNo: '',
              cteKey: '',
              financialInvoiceList: []
            };
            for (const [originalKey, value] of Object.entries(item)) {
              transformedItem.waybillNumber = item.waybillNumber;
              transformedItem.packageNo = item.packageNo;
              transformedItem.cteKey = item.cteKey;
              const taxRate = item.taxRate ? item.taxRate : 0;
              const financialInvoice = {
                taxRate,
                amount: '',
                financialCode: ''
              };
              if (originalKey !== 'waybillNumber' && originalKey !== 'packageNo' && originalKey !== 'cteKey' && originalKey !== 'taxRate') {
                financialInvoice['amount'] = value;
                financialInvoice['financialCode'] = originalKey;
                if (originalKey !== 'FY008') {
                  financialInvoice['taxRate'] = 0;
                }
                if (value) {
                  transformedItem.financialInvoiceList.push(financialInvoice);
                }
              }
            }
            return transformedItem;
          });

          // 使用并发控制处理请求
          const concurrencyLimit = 10; // 最大并发数
          this.allResult = [];
          this.successCount = 0;
          this.failCount = 0;

          // 创建一个执行单个请求的函数
          const processItem = async(item) => {
            try {
              const res = await reopenCteInvoice(item, false);
              const successData = {
                waybillNumber: item.waybillNumber,
                packageNo: item.packageNo,
                cteKey: item.cteKey,
                msg: res.data.msg,
                status: res.data.code,
                statusStr: res.data.code === 200 ? '成功(Sucesso)' : '失败(Falha)'
              };
              item.financialInvoiceList.map(list => {
                successData[list['financialCode']] = list['amount'];
                successData.taxRate = list['taxRate'];
              });

              if (successData.status === 200) {
                this.successCount++;
              } else {
                this.failCount++;
              }

              return successData;
            } catch (error) {
              const errorData = {
                waybillNumber: item.waybillNumber,
                packageNo: item.packageNo,
                cteKey: item.cteKey,
                msg: error.data?.msg || error.message,
                status: error.data?.code || 500,
                statusStr: '失败(Falha)'
              };
              item.financialInvoiceList.map(list => {
                errorData[list['financialCode']] = list['amount'];
                errorData.taxRate = list['taxRate'];
              });

              this.failCount++;
              return errorData;
            }
          };

          // 使用并发控制处理所有请求
          for (let i = 0; i < param.length; i += concurrencyLimit) {
            const batch = param.slice(i, i + concurrencyLimit);
            const batchPromises = batch.map(item => processItem(item));
            const batchResults = await Promise.all(batchPromises);
            this.allResult = this.allResult.concat(batchResults);

            // 更新进度
            this.percentage = parseInt((i + batch.length) / param.length * 100);

            // 给浏览器时间处理其他任务
            await new Promise(resolve => setTimeout(resolve, 0));
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    // 关闭
    confirmClose() {
      this.showBatchCancelResult = false;
      this.successCount = 0;
      this.failCount = 0;
      this.percentage = 0;
      this.fileList = [];
      this.excelJsonData = [];
      this.$emit('closeWindow');
    },
    // 下载取消结果
    downloadResult() {
      const that = this;
      const ddd = async() => {
        const wb = new ExcelJs.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: 'waybillNumber(运单号)',
            key: 'waybillNumber',
            width: 30
          },
          {
            header: 'packageNo(子包号)',
            key: 'packageNo',
            width: 30
          },
          {
            header: 'cteKey(发票密钥)',
            key: 'cteKey',
            width: 50
          },
          {
            header: 'frete(快递费)',
            key: 'FY001',
            width: 20
          },
          {
            header: '% gris e advalorem(从价)',
            key: 'FY013',
            width: 30
          },
          {
            header: 'seguro(保险)',
            key: 'FY005',
            width: 20
          },
          {
            header: '% Tax (ICMS / ISS)(icms税率，必须小于1)',
            key: 'taxRate',
            width: 50
          },
          {
            header: 'valorIcms(icms税费)',
            key: 'FY008',
            width: 20
          },
          {
            header: '状态(Estado)',
            key: 'statusStr',
            width: 30
          },
          {
            header: '失败原因(Razões do fracasso)',
            key: 'msg',
            width: 50
          }
        ];
        const Sheet1_data = [];
        that.allResult.map((item) => {
          Sheet1_data.push({
            waybillNumber: item.waybillNumber,
            packageNo: item.packageNo,
            cteKey: item.cteKey,
            FY001: item.FY001,
            FY013: item.FY013,
            FY005: item.FY005,
            taxRate: item.taxRate,
            FY008: item.FY008,
            statusStr: item.statusStr,
            msg: item.msg
          });
        });
        Sheet1.addRows(Sheet1_data);
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = '补开cte发票结果(Resultado da Reabertura da Fatura CT-e).xlsx'; // '揽收装车记录.xlsx'
        saveAs(blob, saveName);
      };
      ddd();
    }
  }
};
</script>

<style scoped>

</style>
